"use client";

import { useEffect } from "react";
import dynamic from "next/dynamic";

const CUSTOM_PAGES: Record<string, React.ComponentType> = {
  "czr-merger-100pct": dynamic(
    () => import("@/app/trades/[slug]/CzrMergerPageV2"),
    { ssr: false }
  ),
  "spx-oil-0dte-83pct": dynamic(
    () => import("@/app/trades/[slug]/SpxOil0dtePage"),
    { ssr: false }
  ),
  "earnings-iv-crush-84pct": dynamic(
    () => import("@/app/trades/[slug]/EarningsIvCrushPage"),
    { ssr: false }
  ),
  "nvda-iran-short-77pct": dynamic(
    () => import("@/app/trades/[slug]/NvdaIranShortPage"),
    { ssr: false }
  ),
  "vol-skew-spreads-250pct": dynamic(
    () => import("@/app/trades/[slug]/VolSkewSpreadPage"),
    { ssr: false }
  ),
  "ai-options-trading-guide": dynamic(
    () => import("@/app/trades/[slug]/OptionsGuidePage"),
    { ssr: false }
  ),
  "how-to-day-trade-with-ai": dynamic(
    () => import("@/app/trades/[slug]/DayTradingGuidePage"),
    { ssr: false }
  ),
  "whale-watching-flow-strategy": dynamic(
    () => import("@/app/trades/[slug]/WhaleWatchingFlowPage"),
    { ssr: false }
  ),
  "insider-cluster-small-cap-strategy": dynamic(
    () => import("@/app/trades/[slug]/InsiderClusterStrategyPage"),
    { ssr: false }
  ),
  "market-recap-jun29-jul3-2026": dynamic(
    () => import("@/app/trades/[slug]/MarketRecapJun29Page"),
    { ssr: false }
  ),
};

export default function BlogArticleClient({ slug }: { slug: string }) {
  const CustomPage = CUSTOM_PAGES[slug];

  // Hide the server-rendered SEO article once the interactive version mounts
  useEffect(() => {
    if (!CustomPage) return;
    const seoArticle = document.querySelector(".blog-seo-article");
    if (seoArticle) (seoArticle as HTMLElement).style.display = "none";
  }, [CustomPage]);

  if (CustomPage) {
    return <CustomPage />;
  }

  return null;
}
